module.exports = __webpack_public_path__ + "media/images/Cowell_logo-1f98e69c9b89f733d7971de42a15a604.png";